/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Metadata_Scan_YesInputs */

const en_player_metadata_scan_yes = /** @type {(inputs: Player_Metadata_Scan_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const fr_player_metadata_scan_yes = /** @type {(inputs: Player_Metadata_Scan_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_player_metadata_scan_yes = /** @type {(inputs: Player_Metadata_Scan_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_player_metadata_scan_yes = /** @type {(inputs: Player_Metadata_Scan_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÌ`)
};

const ru_player_metadata_scan_yes = /** @type {(inputs: Player_Metadata_Scan_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const es_player_metadata_scan_yes = /** @type {(inputs: Player_Metadata_Scan_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const zh_cn2_player_metadata_scan_yes = /** @type {(inputs: Player_Metadata_Scan_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的`)
};

const ja_player_metadata_scan_yes = /** @type {(inputs: Player_Metadata_Scan_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const hi_player_metadata_scan_yes = /** @type {(inputs: Player_Metadata_Scan_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const pt_pt2_player_metadata_scan_yes = /** @type {(inputs: Player_Metadata_Scan_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Player_Metadata_Scan_YesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_metadata_scan_yes = /** @type {((inputs?: Player_Metadata_Scan_YesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Metadata_Scan_YesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_metadata_scan_yes(inputs)
	if (locale === "de") return de_player_metadata_scan_yes(inputs)
	if (locale === "it") return it_player_metadata_scan_yes(inputs)
	if (locale === "ru") return ru_player_metadata_scan_yes(inputs)
	if (locale === "es") return es_player_metadata_scan_yes(inputs)
	if (locale === "zh-CN") return zh_cn2_player_metadata_scan_yes(inputs)
	if (locale === "ja") return ja_player_metadata_scan_yes(inputs)
	if (locale === "hi") return hi_player_metadata_scan_yes(inputs)
	if (locale === "pt-PT") return pt_pt2_player_metadata_scan_yes(inputs)
	return en_player_metadata_scan_yes(inputs)
});